module.exports = __webpack_public_path__ + "img/24.3b62430b.webp";